import { css } from '@emotion/react'
import styled from '@emotion/styled'
import Button from '@mui/material/Button'
import Popover from '@mui/material/Popover'
import { shouldForwardProp } from 'commons/utils/mui'
import { theme } from 'styles/theme/hav-theme'

type StyledButtonProps = {
  open: boolean
  hasBorder: boolean
  required?: boolean
}

type WrapperProps = {
  fullWidth?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      flex-grow: 1;

      > button {
        display: flex;
        flex-grow: 1;
        justify-content: space-between;
      }
    `}
`
export const StyledButton = styled(Button, { shouldForwardProp })<StyledButtonProps>`
  text-transform: none;
  height: 30px;
  padding: 0 ${theme.spacing.md};
  border-radius: ${theme.shapes.borderRadius.sm};
  background: ${theme.colors.neutral.white};
  font-size: ${theme.typography.sizes.xs};
  font-weight: ${theme.typography.weight.lg};
  line-height: ${theme.typography.lineHeight.sm};
  color: ${theme.colors.neutral.high};
  ${({ hasBorder }) => (hasBorder ? `border: 1px solid ${theme.colors.neutral.clear}` : 'none')};
  ${({ required }) => (required ? `border: 1px solid ${theme.colors.alert.danger.main}` : 'none')};

  :hover {
    background: ${theme.colors.neutral['100']};
  }

  & .MuiButton-endIcon {
    transition: transform 0.2s ease-in-out;
    ${({ open }: { open: boolean }) => open && `transform: scale(-1)`}
  }

  :disabled {
    & .MuiButton-endIcon {
      svg {
        fill: ${theme.colors.neutral.medium};
      }
    }
  }
`
export const StyledPopover = styled(Popover)`
  margin-top: 5px;

  & .MuiPaper-root {
    border-radius: 4px;
    padding: 8px 5px 8px 15px;
    box-shadow: 0px 1px 3px 0px rgba(51, 69, 96, 0.2);
  }
`

export const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`

export const InputWrapper = styled.div`
  padding-right: ${theme.spacing.sm};
`

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 140px;
  width: 200px;
  border: 1px solid ${theme.colors.neutral.mediumhover};
  border-radius: ${theme.shapes.borderRadius.sm};
  gap: ${theme.spacing.xs};
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  cursor: text;

  :hover {
    border: 1px solid ${theme.colors.neutral.medium};
  }

  :focus-within {
    border: 1px solid ${theme.colors.primary.main};
  }

  textarea {
    display: flex;
    border: none;
    outline: none;
    height: 130px;
    width: 100%;
    font-size: ${theme.typography.sizes.sm};
    color: ${theme.colors.neutral.high};
    font-family: ${theme.typography.family.primary};
    resize: none;

    ::placeholder {
      color: ${theme.colors.neutral.lighthover};
    }
  }
`

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: ${theme.spacing.sm};
  gap: ${theme.spacing.xs};
`
